import { schedule } from "@/services/MockData/Dropdown/schedule";
import { HTTP_METHODS } from "@/utils/constants/httpMethods";

export const DROPDOWN_CONFIG = {
    ACTYVITY_TYPE_DROPDOWN_LIST: {
        endPoint: 'dropdown-config?dropdownName=activityType',
        method: HTTP_METHODS.GET,
        // mockData: activitiesType,
    },
    SALES_TYPE_DROPDOWN_LIST: {
        endPoint: 'dropdown-config?dropdownName=salesTargetType',
        method: HTTP_METHODS.GET,
        // mockData: salesTargetType,
    },
    STORE_SELECTOR_DROPDOWN_LIST: {
        endPoint: 'dropdown-config?dropdownName=storeSelector',
        method: HTTP_METHODS.GET,
        // mockData: storeSelector,
    },
    ACTIONS_DROPDOWN_LIST: {
        endPoint: 'dropdown-config?dropdownName=bulkPointModifierActions',
        method: HTTP_METHODS.GET,
        // mockData: actions,
    },
    SCHEDULE_DROPDOWN_LIST: {
        endPoint: 'dropdown-config?dropdownName=schedule',
        method: HTTP_METHODS.GET,
        mockData: schedule,
    },
}
